export default {
  labelLancamentoMastiteLote: 'Inclusión de mastitis en lote',
  selecioneTratamento: 'Seleccionar tratamiento',
  selecioneBacteria: 'Selecciona las bacterias',
  selecioneTipoMastite: 'Seleccione el tipo de mastitis',
  selecioneCuraClinica: 'Seleccionar cura clínica',
  selecioneGrau: 'Seleccionar grado',
  selecioneTipoResultado: 'Seleccionar tipo de resultado',
  labelRetornar: 'Retorno',
  labelTipoLeitura: 'Tipo Lectura',
  labelAcoes: 'Acciones',
  btnResultados: 'Resultados',
  btnFichaVaca: 'Ficha de la Vaca',
  btnTratamentos: 'Tratamientos',
  btnRelatorios: 'Informes',
  labelParabens: '¡Felicitaciones, estás',
  labelEconomizando: 'ahorrando!',
  btnSaibaMais: 'Saber Más',
  labelLojaOnfarm: 'Tienda Onfarm',
  labelDescricaoLojaOnfarm: '¿Qué es la tienda Onfarm y',
  labelBeneficiosLojaOnfarm: 'qué beneficios trae?',
  labelVoceTem: 'Tú tienes',
  btnAcessarLoja: 'Acceder a la Tienda',
  btnLancamento: 'Lanzamiento',
  labelResultados: 'Resultados',
  labelQuarto: 'Cuarto',
  labelTarefas: 'Tareas',
  labelFiltrar: 'Filtrar',
  labelPesquisar: 'Buscar',
  labelBrinco: 'ID',
  labelData: 'Fecha',
  labelTipo: 'Caso',
  labelTratamentos: 'Tratamientos',
  labelLeituraResultados: 'Resultados de lectura',
  labelResultado: 'Resultado:',
  labelCuraClinica: 'Cura clínica:',
  labelVoceEconomizou: 'Usted ahorra:',
  labelMinhasTarefas: 'Mis tareas',
  labelLancamentosRapidos: 'Lanzamientos rápidos',
  btnLancarMastite: 'Registrar mastitis',
  labelUsuario: 'Usuario',
  login_labelDigiteNomeUsuario: 'Introduzca su nombre de usuario',
  labelSenha: 'Contraseña',
  login_labelDigiteSuaSenha: 'Escribe tu contraseña',
  login_labelEsqueciMinhaSenha: 'Olvide mi contraseña',
  login_btnEntrar: 'INICIAR SESIÓN',
  login_btnEntrando: 'INGRESANDO...',
  login_returnCamposUsuarioObrigatorio: 'Los campos de nombre de usuario y contraseña son obligatorios!',
  login_returnDefinirNovaSenha: 'Necesita establecer una nueva contraseña.',
  forgotPassword_labelUsuario: 'Usuario',
  forgotPassword_labelDigiteNomeUsuario: 'Introduzca su nombre de usuario',
  forgotPassword_labelSelecioneReceberSenhaTemporaria: 'Seleccione cómo desea recibir la contraseña temporal',
  forgotPassword_btnEnviar: 'MANDAR',
  forgotPassword_btnEnviando: 'ENVIANDO...',
  forgotPassword_returnNecessarioSelecionarOpcao: 'Debe seleccionar una opción',
  forgotPassword_returnCampoUsuarioObrigatorio: 'El campo de usuario es obligatorio',
  forgotPassword_returnFoiEnviadoSenhaTemporaria: 'Una contraseña temporal ha sido enviada por ',
  forgotPassword_returnFacaLogin: 'Iniciar sesión',
  labelBemVindo: 'Bienvenido',
  labelSelecioneFazendaAvancar: 'Seleccione la granja para avanzar',
  farm_labelPesquiseFazenda: 'Buscar una granja',
  farm_btnProsseguir: 'Continuar',
  labelAjuda: 'Ayudar',
  footer_btnInicio: 'Inicio',
  labelNovoUsuario: 'Nuevo Usuario',
  footer_btnNotificacao: 'Notificaciones',
  homeBezerra_labelTitulo: 'salud de las terneras',
  homeBezerra_btnIrparaLoja: 'Ir a la tienda',
  homeBezerra_btnMinhasTarefas: 'Mis Tareas',
  homeBezerra_btnBancoColostro: 'Banco de Calostro',
  homeBezerra_btnColostragem: 'Calostrado',
  homeBezerra_btnTratamentos: 'Tratamientos',
  homeBezerra_btnFichaBezerra: 'Ficha de la Ternera',
  homeBezerra_btnDoencas: 'Enfermedades',
  labelGrafico: 'Gráficos',
  homeBezerra_btnRelatorio: 'Informes',
  homeBezerra_btnContato: 'Contacto',
  homeBezerra_btnSincronizar: 'Sincronizar',
  labelTop5IntramamarioAgentes: 'Productos más utilizados por la comunidad OnFarmers',
  labelSelecioneAgentes: 'Seleccionar agentes',
  labelOnfarmersTop5IntramamarioATB: 'Top 5 - ATB Intramamarios',
  labelOnfarmersTop5InjetavelATB: 'Top 5 - ATB Inyectable',
  labelOnfarmersTop5AntiflamatorioATB: 'Top 5 - ATB Antiflamatorio',
  labelOnfarmersTop5IntramamariosAgentes: 'Top 5 - ATB Intramamaria por Agentes',
  labelOnfarmersDiasTratamentoIntramamariosAgentes: 'Días de tratamiento ATB Intramamaria por Agente',
  labelOnfarmersCuraClinica: 'Curación Clínica',
  labelMeusDados: 'Mis datos',
  labelDadosUsuario: 'Datos del usuario',
  labelDadosFazenda: 'Datos de la granja',
  labelAlterarSenha: 'Cambiar contraseña',
  labelMinhasContas: 'Mis cuentas',
  labelRastreioPedidos: 'Rastreo de Orden',
  labelVacasLactacao: 'Vacas en Lactancia',
  labelUsuarioFazendas: 'Usuarios/Granjas',
  labelUsuarios: 'Usuarios',
  labelFazendas: 'Granjas',
  labelAlternarFazenda: 'Cambiar de Granja',
  labelArtigosVideos: 'Articulos y Videos',
  labelIntegracoes: 'integraciones',
  labelTokenOnfarm: 'Ficha en la granja',
  labelParceiros: 'Socios',
  labelUtilidades: 'Utilidades',
  labelRepararBancoDados: 'Reparar base de datos',
  labelDiagnosticoAparelho: 'Diagnóstico del dispositivo',
  labelDados: 'Datos',
  labelExportarBancoDeDados: 'Exportar Base de Datos',
  labelCentralNotificacao: 'Centro de notificaciones',
  labelSair: 'Salir',
  homeUbere_btnIrParaLoja: 'Ve a la tienda',
  homeUbere_btnMInhasTarefas: 'Mis tareas',
  homeUbere_btnFichaVaca: 'Ficha de la Vaca',
  homeUbere_btnTratamentos: 'Tratamientos',
  btnGraficos: 'Gráficos',
  homeUbere_btnRelatorios: 'Informes',
  labelAnaliseCbtTanque: 'Análisis de tanques CBT',
  homeUbere_btnContato: 'Contacto',
  btnComunidadeOnfarmers: 'Comunidad',
  homeUbere_btnSincronizar: 'Sincronizar',
  homeUbere_btnRumiTank: 'Last measurement',
  dadosUsuario_labelDadosUsuario: 'Datos del usuario',
  dadosUsuario_labelDadosFazenda: 'Datos de la granja',
  labelNome: 'Nombre',
  labelID: 'ID',
  labelLogin: 'Acceso',
  labelPerfil: 'Perfil',
  labelEmail: 'Correo electrónico',
  labelTelefone: 'Teléfono',
  labelFazenda: 'Granja',
  labelIdioma: 'Idioma',
  labelAtivarPopupCuraClinica: 'Activar Pop-up cura clínica',
  labelAtivarPopupVacasLactacao: 'Activar Pop-up vacas lactantes',
  dadosUsuario_returnAtualizadoSucesso: '¡Actualizado con éxito!',
  labelAtualizar: 'Actualizar',
  labelLaticinios: 'Lácteos',
  labelNumVacasLactacao: 'Número de vacas lactantes',
  labelVolumeLeite: 'Volumen de leche (L/día)',
  labelSistemaProducao: 'Sistema de producción',
  labelCidade: 'Ciudad',
  labelEstado: 'Departamento',
  labelOrganizacaoPrincipal: 'Organización principal',
  alterarSenha_labelCriarNovaSenha: 'Crear nueva contraseña',
  alterarSenha_labelDigiteNovaSenha: 'Introduzca una nueva contraseña',
  alterarSenha_labelConfirmarNovaSenha: 'Confirmar nueva contraseña',
  alterarSenha_labelConfirmeNovaSenha: 'Confirma tu nueva contraseña',
  alterarSenha_returnSenhaConfirmacaoSenhaObrigatorios: 'Se requiere contraseña y confirmación de contraseña!',
  alterarSenha_returnMinimoDigitos: 'Mínimo de 6 dígitos',
  alterarSenha_returnSenhasDevemIguais: '¡Las contraseñas deben ser las mismas!',
  returnSenhaAlteradaSucesso: '!Contraseña alterada con éxito!',
  alterarSenha_returnErroAlterarSenha: '!Error al cambiar la contraseña!',
  alterarSenha_returnTenteNovamenteInstantes: 'Vuelve a intentarlo en un momento.',
  rastreioPedido_filtroEnviado: 'Enviado',
  rastreioPedido_filtroAguardandoFaturamento: 'Previsto',
  rastreioPedido_filtroAutorizado: 'Enviado',
  rastreioPedido_filtroFaturado: 'Faturado',
  rastreioPedido_filtroCancelado: 'Cancelado',
  rastreioPedido_filtroDevolvido: 'Devolvido',
  rastreioPedido_filtroDevolvidoParcialmente: 'Devolvido Parcialmente',
  rastreioPedido_filtroDenegado: 'Denegado',
  rastreioPedido_filtroPrevisto: 'Visto el futuro',
  rastreioPedido_filtroEntregue: 'Entregado',
  labelPedido: 'Pedido',
  rastreioPedido_colStatus: 'Estatus',
  rastreioPedido_colData: 'Fecha',
  rastreioPedido_filtroPedido: 'Pedido',
  rastreioPedido_filtroStatus: 'Estatus',
  rastreioPedido_filtroDataVencimento: 'Fecha de vencimiento',
  rastreioPedido_filtroFILTRAR: 'FILTRAR',
  labelPeriodo: 'Curso de tiempo',
  vacaLactacao_colQuantidade: 'La cantidad',
  vacaLactacao_filtroQuantidade: 'La cantidad',
  usuario_colUsuário: 'Usuario',
  usuario_colPerfil: 'Perfil',
  usuario_colFazenda: 'Granja',
  usuario_title: 'Usuarios',
  usuario_filtoUsuario: 'Usuario',
  usuario_returnCampoNomeObrigatorio: '¡El campo de nombre es obligatorio!',
  usuario_returnCampoLoginObrigatorio: '¡El campo de inicio de sesión es obligatorio!',
  usuario_returnSelecioneAoMenosUmPerfil: '¡Seleccione al menos un perfil!',
  usuario_returnSelecioneAoMenosUmaFazenda: '¡Seleccione al menos una granja!',
  usuario_returnHabiliteAoMenosUmaPermissao: '¡Habilitar al menos un permiso!',
  usuario_labelNome: 'Nombre',
  usuario_labelLogin: 'Acceso',
  labelPerfilUsuario: 'Perfil del usuario',
  usuario_labelFazendas: 'Granjas',
  usuario_labelEmail: 'Correo electrónico',
  usuario_labelTelefone: 'Teléfono',
  labelPermissoesUsuario: 'Permisos de usuario',
  usuario_returnEsteLoginJaExiste: '¡Este inicio de sesión ya existe, inserte outro!',
  repararBD_returnRepararBanco: 'Banco de reparación',
  repararBD_returnApagandoBanco: 'Eliminando banco...',
  repararBD_returnReparacaoConcluidaSucesso: 'Reparación completada con éxito',
  repararBD_returnReparando: 'Reparando...',
  repararBD_returnDesejaRealmenteAlternarFazenda: 'De verdad quieres cambiar de granja?',
  repararBD_returnDesejaRealmenteRepararBanco: '¿Realmente quieres reparar la base de datos?',
  repararBD_returnIssoPodeApagarTodosDados: 'Esto puede borrar todos tus datos.',
  repararBD_returnAtencao: '¡Aviso!',
  repararBD_returnConstamDadosParaSincronizar: '¿Hay datos para sincronizar, ¿te gustaría sincronizar?',
  repararBD_returnIssoApagarTodosDados: 'Esto borrará todos sus datos.',
  export_labelExportBD: 'Base de Datos',
  export_labelTamBanco: 'Tamaño de la base de datos local',
  export_labelExportar: 'ENVIAR COPIA DEL BANCO',
  export_labelExportando: 'ENVIANDO...',
  export_labelExportado: 'Enviado',
  export_labelExportadocaoConcluida: '¡Envío completado con éxito!',
  export_labelExportadoModal: 'Enviando',
  export_labelExportadoDescricaoModal: 'Envío de una copia de la base de datos local al servidor',
  labelNovaFazenda: 'Nueva Granja',
  labelNomeProprietario: 'Nombre del dueño',
  labelVideos: 'Vídeos',
  labelVideo: 'Video',
  labelArtigos: 'Artículos',
  labelArtigo: 'Artículo',
  labelUbere: 'Ubre',
  labelBezerra: 'Novilla',
  labelTitulo: 'Título',
  artigo_labelTipo: 'Escribe',
  labelCategoria: 'Categoría',
  labelTutorias: 'Tutoriales',
  labelIdFazenda: 'id Granja',
  labelGerandoToken: 'Generando Ficha...',
  labelGerarToken: 'Generar Ficha',
  labelTokenGerado: 'Ficha generada',
  diagnostico_labelDiagosticoAparelho: 'Dispositivo de diagnóstico',
  diagnostico_labelArmazenamento: 'Almacenamiento',
  diagnostico_labelDoArmazenamento: 'del almacenamiento',
  diagnostico_labelMemoria: 'Memoria',
  diagnostico_labelDaMemoriaRAM: 'de memoria RAM',
  diagnostico_labelInternetWifi: 'Internet-Wifi',
  diagnostico_labelDoSinal: 'de la señal',
  diagnostico_labelFabricanteModelo: 'Fabricante/Modelo',
  diagnostico_labelPlataforma: 'Plataforma',
  notificacao_labelAtiveDesativeNotificacao: 'Activar o desactivar las notificaciones',
  fichaVaca_labelInformaçãoSuplementar: 'Información suplementaria',
  fichaVaca_labelVolumeLeite: 'Volumen de leche',
  fichaVaca_labelNumero: 'Número',
  fichaVaca_labelInibidorMicrobiologico: 'Inhibidor microbiológico',
  fichaVaca_labelMotivoDescarte: 'Motivo del descarte',
  fichaVaca_labelGordura: 'Grasa',
  fichaVaca_labelProteína: 'Proteína',
  fichaVaca_labelLactose: 'Lactosa',
  fichaVaca_labelSolidosTotais: 'Solidos totales',
  fichaVaca_labelCCS: 'CCS',
  fichaVaca_labelCCP: 'PCCh',
  fichaVaca_labelNUreico: 'N Urea',
  fichaVaca_labelCaseina: 'Caseína',
  fichaVaca_labelCrioscopia: 'Crioscopia',
  fichaVaca_labelAniversario: 'Cumpleaños',
  fichaVaca_labelDataCCS: 'Fecha CCS',
  fichaVaca_labelDataUltimoRegistroLeite: 'Fecha del último registro de leche',
  fichaVaca_labelUltimoRegistroLeiteKg: 'Último Registro de Leche en Kg',
  fichaVaca_labelDataUltimoParto: 'Última fecha de entrega',
  fichaVaca_labelDataPrevistaSecagem: 'Fecha de secado esperada',
  fichaVaca_labelDEL: 'DEL',
  fichaVaca_labelDataProducaoLeite: 'Fecha de producción de leche',
  fichaVaca_labelProducaoLeite: 'Producción de leche',
  fichaVaca_labelDataMastite: 'Fecha de Mastitis',
  fichaVaca_labelImportacao: 'Importar',
  fichaVaca_labelNdeCasos: 'Nº de Casos Clínicos',
  tratamento_returnCampoDescricaoObrigatorio: 'Campo Descripción requerido',
  tratamento_returnSelecioneUmTipoMastite: 'Seleccione un tipo de mastitis',
  tratamento_returnSelecioneUmGrau: 'seleccione un grado',
  tratamento_returnSelecioneUmaObservacao: 'seleccione una observación',
  tratamento_returnSelecioneUmResultado: 'Seleccione un resultado',
  tratamento_returnSelecionePeloMenosUmaBacteria: 'Seleccione al menos una bacteria',
  tratamento_returnSelecioneUmOpcaoAtivo: 'Seleccione una opción activa',
  tratamento_returnSalvoComSucesso: 'Guardado exitosamente',
  returnDesejaMesmoSalvarEsteTratamento: '¿Desea guardar este tratamiento?',
  tratamento_labelEditarTratamento: 'Editar tratamiento',
  tratamento_labelNovoTratamento: 'Nuevo tratamiento',
  labelDescricao: 'Descripción',
  labelCodigoIntegracaoIdeagri: 'Código de Integración Ideagri',
  labelTipoMastite: 'Tipo de mastitis',
  tratamento_labelGrau: 'Grado de mastitis',
  tratamento_labelEscoredeChancedeCura: 'Probabilidad de cura',
  tratamento_labelObservação: 'Observación',
  labelAntibioticoInjetavel: 'Antibiótico inyectable',
  tratamento_labelSelante: 'Terapia de secado',
  tratamento_labelAtivo: 'Activo? ',
  tratamento_labelAtualizarProtocolo: 'PROTOCOLO DE ACTUALIZACIÓN',
  tratamento_labelAdicionarProtocolo: 'AGREGAR PROTOCOLO',
  tratamento_labelDigiteValorValido: 'Introduzca un valor válido',
  tratamento_labelBaixo: 'Baja',
  tratamento_labelMédio: 'Media',
  tratamento_labelAlto: 'Alta',
  labelLeve: 'Leve',
  labelModerado: 'Moderado',
  labelGrave: 'Grave',
  tratamento_labelCSSAlta: 'Alto CCS',
  labelManha: 'Mañana',
  labelTarde: 'Tarde',
  labelNoite: 'Noche',
  labelRepetirEsteMedicamento: 'Repita este medicamento durante el día durante los siguientes períodos',
  tratamento_labelPesquiseProdutos: 'Búsqueda de Productos',
  tratamento_labelPesquise: 'Búsqueda',
  labelAdicionarMedicamento: 'agregar medicamento ',
  tratamento_returnDigiteNomePesquisa: 'Introduzca el nombre en el campo de búsqueda',
  labelSelecioneBacterias: 'Seleccionar las bacterias',
  tratamento_labelPesquiseBacteria: 'Busca las bacterias...',
  home_labelVoceEconomizouAteMomento: 'Has guardado hasta ahora',
  labelOcorrenciaMastiteClinica: 'Ocurrencia de mastitis clínica',
  labelIncidenciaMastiteClinica: 'Incidencia de Mastitis Clínica',
  labelAgentesCausadoresMastite: 'Agentes causantes de mastitis',
  labelPrevalenciaGrupoGRAM: 'Prevalencia por grupo GRAM',
  labelCuraClinicaDiagnóstico: 'Curación clínica por diagnóstico',
  labelConsolidadoDiagnostico: 'Consolidado - Diagnóstico',
  labelCasosMastiteTratamento: 'Casos de mastitis y tratamientos por día',
  labelConsolidadoDiagnosticoTratamento: 'Consolidado - diagnósticos, tratamientos y cura clínica',
  labelExportacaoIdeagri: 'Exportación - Ideagri',
  labelExportacaoACL: 'Exportar - LCA',
  tanque_labelAnaliseCBTTanque: 'Análisis de tanques CBT',
  labelTanque: 'Tanque',
  tanque_labelData: 'Fecha',
  tanque_labelCCS: 'CCS',
  tanque_labelCBT: 'CBT',
  tanque_labelNovoTanque: 'Tanque Nuevo',
  tanque_labelDescricao: 'Descripción',
  labelVolume: 'Volumen',
  labelProteina: 'Proteína',
  tanque_labelDigiteDescricao: 'Introduce la descripción',
  tanque_labelDigiteVolume: 'Introduce el volumen',
  tanque_labelDataColeta: 'Fecha de colección',
  labelGordura: 'Grasa',
  tanque_labelLERCODIGODEBARRAS: 'LER CÓDIGO CBTest',
  tanque_labelDigiteProteina: 'Introduce la proteína',
  tanque_labelDataLancamento: 'Fecha de lanzamiento',
  tanque_labelCampoDescricaoNaoPreenchido: 'Campo descrição não preenchido',
  labelEssaPlacaJaFoiUtilizada: 'Essa Placa já foi utilizada',
  tanque_labelValidando: 'Validando...',
  tanque_labelSalvarNovoTanque: 'GUARDAR TANQUE NUEVO',
  tanque_labelTanqueNaoConstaFotoServidor: 'El tanque no se muestra en el servidor',
  labelAjudaGuiaCores: 'Ayuda Guía de colores',
  labelContagemColonias: 'Recuento de colonias',
  labelManual: 'Manual',
  labelAutomatico: 'Automático',
  labelNumColonias: 'Número de colonias',
  labelDiluicao: 'Dilución',
  labelCBTest: 'Prueba CBT',
  labelAtualizarTanque: 'TANQUE DE ACTUALIZACIÓN',
  labelEmAnalise: 'En análisis',
  returnTanqueAtualizandoComSucesso: 'Tanque actualizado con éxito!',
  tanque_labelCampoTipoContagem: 'Seleccionar tipo de conteo',
  boasVindas_textTexto001: 'BIENVENIDA!',
  boasVindas_textTexto002: 'Hola yo soy',
  boasVindas_textTexto003: 'Bienvenido a la Nueva OnfarmApp!',
  boasVindas_textTexto004: 'Mientras espera la sincronización, aquí hay un consejo de Novo OnFarmApp',
  boasVindas_textTexto005: 'Aquí también tendrás a Rumi, nuestra inteligencia artificial.',
  boasVindas_textTexto006: 'activado',
  boasVindas_textTexto007: '  y seguirá haciendo su trabajo cada vez que necesite leer un resultado en la placa, o un análisis de la puntuación de probabilidad de curación de los casos de mastitis clínica.',
  boasVindas_textTexto008: 'VISITA MI PAGINA',
  colostro_labelLote: 'Lote',
  colostro_labelData: 'Fecha',
  colostro_labelVolume: 'Volumen',
  colostro_labelBrix: 'Brix',
  colostro_labelCBT: 'CBT',
  colostro_labelBancoColostro: 'Banco de calostro',
  colostro_labelBrincoBezerra: 'RP de la Ternera',
  colostro_labelDigiteUmLote: 'Introduce un lote',
  colostro_labelBrixColostro: 'Brix Calostro',
  returnColostroAtualizadoSucesso: 'Calostro actualizado con éxito!',
  colostro_returnAdicioneBrinco: 'Agrega el arete',
  colostro_returnAdicioneAoMenosUmPacote: 'Agregar al menos un paquete',
  colostro_returnPorFavorAnexeUmaImagem: 'Adjunte una imagen',
  returnFavorAguardeProcessamentoAutomatico: 'Por favor, espere el procesamiento automático.',
  colostro_returnErroProcessarImagemTireUmaNovaFoto: 'Error al procesar la imagen. ¡Toma una nueva foto e inténtalo de nuevo!',
  colostro_btnEditarColostro: 'Editar calostro',
  colostro_btnNovoColostro: 'Nuevo calostro',
  colostro_labelVaca: 'Vaca',
  colostro_labelDensidadeColostometro: 'Densidad (colostómetro)',
  colostro_btnSALVARCOLOSTRO: 'AHORRE CALOSTRO',
  colostro_btnADICIONARCOLOSTRO: 'AGREGAR CALOSTRO',
  colostro_btnADICIONANDO: 'AGREGAR...',
  colostro_labelDataCongelamento: 'Fecha de congelación',
  colostro_labelAdicioneQuantidadePacotesVolumesForamCongelados: 'Agregar cantidad de paquetes y volúmenes que fueron congelados',
  colostro_labelInsiraPacotesVolumes: 'Insertar paquetes y volúmenes',
  colostro_labelPacotes: 'paquetes',
  colostro_labelVolumeLPacotes: 'Volumen (L/Paquetes)',
  colostro_labelAdicionarPacotesVolume: 'Agregar Paquetes y Volumen',
  colostro_labelNumPacotes: 'Nº Paquetes',
  colostro_labelVolumePct: 'volumen del paquete',
  colostro_labelVolumeTotal: 'Volumen total',
  colostro_labelTotal: 'Total',
  colostro_labelEssaPlacaJaFoiUtilizada: 'Esta placa ha sido utilizada',
  colostro_labelLERCODIGOBARRAS: 'LEER CÓDIGO CBTest',
  colostro_labelValidando: 'Validando...',
  lancBezerra_btnNovoColostro: 'Nuevo Calostro',
  lancBezerra_btnNovaColostragem: 'Nuevo Calostrado',
  lancBezerra_labelLeituraResultados: 'Lectura de Resultados',
  colostragem_labelColostragem: 'Calostrado',
  colostragem_labelBrincoBezerra: 'RP de la Ternera',
  colostragem_labelLote: 'Lote',
  colostragem_labelDigiteUmLote: 'Introduce un lote',
  colostragem_labelNascimento: 'Nacimiento',
  colostragem_labelBrixColostro: 'Brix Calostro',
  colostragem_labelCBT: 'CBT.',
  colostragem_labelBrixSangue: 'Sangre Brix',
  colostragem_labelBrix: 'Brix',
  colostragem_labelSangue: 'Sangre',
  colostragem_labelEditarColostragem: 'Editar Colostrage',
  colostragem_labelNovaColostragem: 'Nuevo Colostrage',
  colostragem_labelProteinaSerica: 'Proteína sérica',
  colostragem_labelDataNascimento: 'Fecha de nacimiento',
  colostragem_labelVolume: 'Volumen',
  colostragem_labelSelecioneColostro: 'Seleccionar calostro',
  colostragem_labelLoteNecessárioAdicionarNovoPacote: 'Se requiere lote para agregar un nuevo paquete',
  colostragem_labelAdicionarPacotes: 'Agregar paquetes',
  colostragem_labelDesejaRealmenteExcluirEssePacote: 'Realmente desea eliminar este paquete?',
  colostragem_labelVolumeLPacotes: 'Volumen (L/Paquetes)',
  colostragem_labelLoteNaoPodeSerVazio: 'El lote no puede estar vacío',
  colostragem_labelSALVARCOLOSTRAGEM: 'GUARDAR CALOSTRADO',
  colostragem_labelPesoNascimento: 'Peso al Nacer',
  labelLoteNaoEncontrado: 'Lote no encontrado',
  graficoBezerra_labelQualidadeColostroCBT: 'Calidad del Calostro (CBT)',
  graficoBezerra_labelQualidadeColostroBRIX: 'Calidad del Calostro (BRIX)',
  graficoBezerra_labelQualidadeColostroIgGCBT: 'Calidad del Calostro (IgG y CBT)',
  graficoBezerra_labelQualidadeColostragem: 'Calidad de Calostrado',
  graficoBezerra_labelDoencas: 'Enfermedades',
  graficoBezerra_labelConsolidado: 'Consolidado',
  graficoBezerra_labelExportar: 'Generar informe',
  novaHome_labelVerificandoConexao: 'Comprobando conexión...',
  novaHome_labelAguardeEnquantoVerificamosSuaConexao: 'Espere mientras verificamos su conexión a Internet.',
  novaHome_labelBuscandoSinal: 'Buscando señal...',
  novaHome_labelRumiEstaOnline: 'Rumi está en línea!',
  novaHome_labelVocePodeContarRumiFazerLeituraAutomatica: 'Puede contar con Rumi para leer automáticamente los diagnósticos.',
  novaHome_labelFazerLeituraResultados: 'Lectura de resultados',
  novaHome_labelRumiEstaOffline: 'Rumi está desconectado!',
  novaHome_labelVoceEstaSemConexaoInternet: 'No tienes conexión a internet y solo podrás hacer lecturas manuales.',
  novaHome_labelSincronizandoDados: 'Sincronizando datos...',
  novaHome_labelProgresso: 'Progreso',
  novaHome_labelSincronizacaoDisponivel: 'Sincronización disponible',
  novaHome_labelNovosDadosSincronizarServidor: ' nuevos datos para sincronizar con el servidor',
  novaHome_labelSincronizarDadosAgora: 'Sincronizar datos ahora',
  novaHome_labelVoceJaEconomizou: 'Ya has ahorrado',
  novaHome_labelSemConexaoComInternet: 'Sin conexión a Internet',
  novaHome_labelTenteMaisTarde: 'Intenta más tarde',
  novaHome_labelSemWhatsapp: 'sin whatsapp',
  novaHome_labelWhatsappNaoFoiEncontrado: 'WhatsApp no ​​encontrado. Instálalo e inténtalo de nuevo.',
  novaHome_labelTarefasEmAberto: 'tareas abiertas',
  novaHome_labelVerTodas: 'ver todo',
  novaHome_labelNenhumaTarefaParaHoje: 'No hay tareas para hoy.',
  novaHome_labelIrParaSaudeBezerra: 'Ir a Bezerra Salud',
  sincronismo_labelCarregando: 'Cargando...',
  sincronismo_labelPermissoes: 'Permisos',
  sincronismo_labelGrupos: 'Grupos',
  sincronismo_labelTopicosAjuda: 'Temas de Ayuda',
  sincronismo_labelFabricantes: 'Fabricantes',
  sincronismo_labelProdutos: 'productos',
  sincronismo_labelAgentes: 'Agentes',
  sincronismo_labelParametros: 'Parámetros',
  sincronismo_labelAgentesParametros: 'Parámetros de Agentes',
  sincronismo_labelCategoriasNotificacoes: 'Categorías de Notificación',
  sincronismo_labelPreferenciasNotificacoes: 'Preferencias de Notificaciones',
  sincronismo_labelCondicoesNotificacoes: 'Condiciones de Notificación',
  sincronismo_labelAnimais: 'Animales',
  sincronismo_labelFazendas: 'Granjas',
  sincronismo_labelUsuarios: 'Usuarios',
  sincronismo_labelVacasLactacao: 'Vacas en Lactancia',
  sincronismo_labelProtocolos: 'Protocolos',
  sincronismo_labelProtocolosProdutos: 'Protocolos - Productos',
  sincronismo_labelDiagnosticos: 'Diagnóstico',
  sincronismo_labelTarefasProdutos: 'Tareas - Productos',
  sincronismo_labelProtocolosDiagnosticos: 'Protocolos de Diagnóstico',
  sincronismo_labelProtocolosProdutosDiagnosticos: 'Protocolos - Productos de Diagnóstico',
  sincronismo_labelAnaliseTanque: 'Análisis de tanques',
  sincronismo_labelProtocolosBezerra: 'Protocolos Bezerra',
  sincronismo_labelBezerraProtocolosProdutos: 'Protocolos Bezerra - Productos',
  sincronismo_labelDoencas: 'Enfermedades',
  sincronismo_labelTarefasBezerra: 'Tareas de Bezerra',
  sincronismo_labelTarefasBezerraProdutos: 'Bezerra Tareas - Productos',
  sincronismo_labelProtocolosDoencas: 'Protocolos Enfermedades',
  sincronismo_labelProtocolosProdutosDoencas: 'Protocolos - Productos - Enfermedades',
  sincronismo_labelBancoColostro: 'Banco de calostro',
  sincronismo_labelColostragem: 'Colostrage',
  sincronismo_labelPacotesColostro: 'Paquetes de Calostro',
  sincronismo_labelColostragemColostro: 'Colostrage - Calostro',
  sincronismo_labelParceiros: 'Socios',
  sincronismo_labelConfiguracoesParceiros: 'Configuración de Socios',
  geral_labelDadosFazenda: 'Datos de la granja',
  labelSim: 'Sí',
  labelNao: 'No',
  btnSalvarAlteracao: 'GUARDAR CAMBIO',
  labelSalvar: 'Guardar',
  labelSalvando: 'GRABACIÓN.',
  geral_LabelFiltros: 'Filtros',
  geral_LabelRemoverFiltros: 'Quitar filtros',
  geral_returnSemConexaoInternet: 'Sin conexión a Internet',
  geral_returnTenteMaisTarde: 'Intenta más tarde',
  labelImportarDados: 'Datos de importacion',
  geral_btnAtualizar: 'Actualizar',
  geral_btnAtualizando: 'Actualizando...',
  geral_returnSalvoComSucesso: 'Guardado con èxito!',
  geral_returnSalvoComSucessoWhatshapp: 'Os dados de acesso serão enviados por WhatsApp para o contato de telefone informado.',
  geral_returnAtualizadoComSucesso: 'Actualizado exitosamente!',
  labelTodos: 'Todo',
  geral_returnEditadoComSucesso: 'Editado con éxito!',
  geral_returnDesculpe: 'Perdon',
  geral_returnDesejaRealmenteSair: '¿De verdad quieres salir?',
  labelCancelar: 'Cancelar',
  geral_btnConfirmar: 'Confirmar',
  geral_labelDigiteAlgo: 'Escribe algo',
  geral_returnSelecioneFazenda: 'Seleccione una granja',
  geral_labelResultados: 'Resultados',
  labelGrau: 'Grado',
  geral_labelCuraClinica: 'Curación clínica',
  labelEditar: 'Editar',
  labelExcluir: 'Borrar',
  geral_btnVisualizar: 'Para ver',
  labelBacterias: 'Bacterias',
  geral_returnDesejaExcluirEsteDiagnostico: 'Desea eliminar este diagnóstico?',
  labelFiltrarPor: 'Filtrado por',
  geral_labelDataInício: 'Fecha de inicio',
  geral_labelDataFinal: 'Fecha final',
  labelVerMais: 'Ver más',
  labelRealizarLeitura: 'Realizar la lectura',
  geral_labelMaiorQue: 'Más grande que',
  geral_labelMaiorIgualQue: 'Mayor e igual que',
  geral_labelMenorQue: 'Menos que',
  geral_labelMenorIgualQue: 'Menor e igual a',
  labelMastiteClinica: 'Mastitis clínica',
  labelMastiteSubclínica: 'Mastitis subclínica',
  labelMastiteSemCultura: 'Mastitis Sin Cultivo',
  labelSecagem: 'Secado',
  labelPosTratamento: 'Pos-Tratamiento',
  labelPosParto: 'Pos parto',
  geral_labelFichaVaca: 'Ficha de la Vaca',
  labelNumeroCaso: 'Nº Casos Clínicos',
  geral_returnErroFazerUploadArquivo: '¡Error al cargar el archivo!',
  geral_labelImportacaoDados: 'Importación de datos',
  geral_labelSincronizando: 'Sincronizando',
  geral_returnSelecioneUmParceiro: 'Seleccione un socio',
  labelDownloadTemplate: 'Descargar plantilla',
  geral_returnProcessarImportacao: 'Importación de procesos',
  geral_returnBaixandoArquivo: 'Descargando archivo',
  geral_returnWebArquivo: 'Problema en la descarga',
  geral_returnImportandoArquivo: 'Importación de archivo',
  geral_returnSalvandoBibliotecaMídia: 'Guardar en la biblioteca de medios',
  geral_returnBaixandoWeb: 'La descarga del archivo se puede descargar desde la WEB',
  geral_returnEnviandoDadoParaServidor: 'Envío de datos al servidor ',
  labelAgentes: 'Agentes',
  geral_labelSelante: 'Sellador',
  labelCompartilhar001: 'Compartir',
  geral_labelCopiar: 'Copiar',
  labelStatus: 'Situación',
  labelNovoTratamento: 'Nuevo Tratamiento',
  btnExameMicrobiologico: 'Examen microbiológico',
  btnNovaMastiteClinicaSemExame: 'Nueva mastitis clínica SIN examen',
  geral_labelAnaliseCbtTanque: 'Análisis de tanques CBT',
  geral_labelSaudeBezerra: 'Salud de La Ternera',
  geral_labelSaudeUbere: 'Salud de Ubre',
  labelClinica: 'Clinica',
  labelSubclinica: 'Subclinica',
  labelSemCultura: 'Sin Cultivo',
  labelSemResultado: 'No hay resultados',
  labelNegativo: 'Negativo',
  labelPositivo: 'Positivo',
  labelContaminado: 'Contaminado',
  geral_labelExportando: 'Exportador...',
  geral_labelSelecione: 'Elegir',
  geral_labelFILTRAR_EXPORTAR: 'FILTRO Y EXPORTACIÓN',
  btnRemoverFiltros: 'ELIMINAR FILTROS',
  modalAtualVersao_labelAvisoImportante: '¡Advertencia importante!',
  modalAtualVersao_labelVocêEstaUtilizandoVersaoAntiga: 'Estás usando una versión antigua: ',
  modalAtualVersao_labeljaEstaDisponivelNovaVersaoAplicativo: '. Ya está disponible una nueva versión de esta aplicación: ',
  modalAtualVersao_labelCliqueBtnAtualApp: '. Haga clic en el botón "Actualizar aplicación" para continuar usando sus funciones.',
  modalAtualVersao_btnAtualizarApp: 'Actualizar App',
  modalAtualVersao_btnAgoraNao: 'Ahora No',
  geral_modalCancelarOperacao: 'La operación será cancelada, le gustaría realmente salir?',
  geral_textoLeituraAutomaticaPlacaApresentacao: 'Lectura Automática de resultados',
  geral_textoAgoraVocePodePlacaApresentacao001: 'Ahora usted puede contar con ',
  geral_textoAgoraVocePodePlacaApresentacao002: ' para leer sus placas ',
  geral_textoAgoraVocePodePlacaApresentacao003: 'automáticamente!',
  geral_textoAgoraVocePodePlacaApresentacao004: 'Ella es nuestra ',
  geral_textoAgoraVocePodePlacaApresentacao005: 'inteligencia artificial',
  geral_textoAgoraVocePodePlacaApresentacao006: ' y va a traer diversas novedades para facilitar su día a día.',
  geral_btnVerDicasFotografar: 'VER INDICACIONES DE COMO FOTOGRAFIAR',
  geral_btnAnexarFoto: 'ADJUNTAR FOTO',
  geral_btnProximaDica: 'VER PRÓXIMA RECOMENDACIÓN',
  geral_textoDica1Iluminacao001: 'Recomendación 1: Iluminación!',
  geral_textoDica1Iluminacao002: 'Encienda la ',
  geral_textoDica1Iluminacao003: 'luz cerca ',
  geral_textoDica1Iluminacao004: ' del ',
  geral_textoDica1Iluminacao005: 'Smartlab ',
  geral_textoDica1Iluminacao006: 'y la ',
  geral_textoDica1Iluminacao007: 'luz de la cabina',
  geral_textoDica1Iluminacao008: ' de SmartLab.',
  geral_textoDica1Iluminacao009: 'Una buena iluminación ayuda a ',
  geral_textoDica1Iluminacao010: 'realzar los colores',
  geral_textoDica1Iluminacao011: ' de las bacterias y ',
  geral_textoDica1Iluminacao012: 'facilita',
  geral_textoDica1Iluminacao013: ' el correcto reconocimiento algorítmico.',
  geral_labelInicieLançamento: 'Inicie un lanzamiento',
  labelNovaMastiteClinicaSemCultura: 'Nueva mastitis clínica SIN cultivo',
  labelSelecioneQuarto: 'Seleccionar el cuarto: ',
  geral_labelMoeda: '$ ',
  labelOuDigiteCodigoBarras: 'o introduce el código de barras',
  geral_labelLeituraPlacaUbere: 'Lectura de la placa - Ubere',
  geral_labelLeituraPlacaBezerra: 'Lectura de la placa - Bezerra',
  geral_textoCompartilhar: 'Compartir tratamiento',
  geral_btnFinalizar: 'TERMINAR',
  labelQuartoPE: 'PI',
  labelQuartoAE: 'AI',
  labelQuartoPD: 'PD',
  labelQuartoAD: 'AD',
  geral_ativarPopup: 'Activar alarma de ',
  geral_textoAtivarLeituraAutomDiag: 'Activar lectura automática de diagnostico',
  labelLeituraEm: 'Lectura el',
  geral_labelStatusMastiteClinica: 'Mastitis clínica',
  geral_labelStatusMastiteSubClinica: 'Mastitis sub clínica',
  geral_labelStatusMastiteSemCultura: 'Mastitis sin cultivo',
  geral_textoDica2PlacaCentralizada001: 'Recomendación 2: Placa centralizada',
  geral_textoDica2PlacaCentralizada002: 'Posicione la placa en ',
  geral_textoDica2PlacaCentralizada003: 'el Soporte de Lectura de SmartLab ',
  geral_textoDica2PlacaCentralizada004: ' y ajuste de manera correcta y centralizada, evitando que la placa esté torcida.',
  geral_textoDica2PlacaCentralizada005: 'Esto puede ',
  geral_textoDica2PlacaCentralizada006: 'interferir en',
  geral_textoDica2PlacaCentralizada007: ' la muestra y en la etapa que hubo crecimiento.',
  geral_textoDica3AtencaoMarcacao001: 'Recomendación 3: Atención a la marca',
  geral_textoDica3AtencaoMarcacao002: 'Aproxime',
  geral_textoDica3AtencaoMarcacao003: ' la cámara del celular de modo que la placa quede encajada',
  geral_textoDica3AtencaoMarcacao004: ' conforme las marcas',
  geral_textoDica3AtencaoMarcacao005: ' sugeridas.',
  geral_textoDica3AtencaoMarcacao006: 'Es fundamental que la foto ocupe exactamente el espacio marcado ',
  geral_textoDica3AtencaoMarcacao007: 'sin sombras',
  geral_textoDica3AtencaoMarcacao008: ' alrededor',
  geral_textoDica3AtencaoMarcacao009: 'No mostrar estas recomendaciones nuevamente',
  labelNotificacoes: 'Notificaciones',
  geral_textNotificacaoRespQuestCuraCLinica: 'Responder preguntas de cura clínica',
  geral_textNotificacaoAtualizarVacasLactacao: 'Actualizar vacas lactantes',
  geral_textNotificacaoPlaca: 'Placa ',
  geral_textNotificacaoProntaLeitura: '  lista para lectura',
  geral_traducao0001: 'Estamos procesando el reporte y pronto estará disponible para su descarga en notificaciones de OnfarmApp Web. Acceso al link: app.onfarm.com.ar',
  geral_traducao0002: 'Lo siento, pero hubo un error al generar el informe.',
  geral_traducao0003: 'Sin conexión a Internet',
  geral_traducao0004: 'Fecha de inicio mayor que la fecha de finalización.',
  geral_traducao0005: 'Desativar pop-up',
  geral_traducao0006: 'Responder después',
  geral_traducao0007: 'Su respuesta',
  geral_traducao0008: 'Enviar',
  geral_traducao0009: 'El grumo desapareció y no volvió mas a esa cuarto',
  geral_traducao0010: 'CURO',
  geral_traducao0011: 'Regreso o continuo presente en ese cuarto',
  geral_traducao0012: 'NO CURO',
  geral_traducao0013: 'Se descarto',
  labelSeca: 'Se seco',
  geral_traducao0015: 'Próximo',
  geral_traducao0016: 'Confirmación',
  geral_traducao0018: 'Ver detalles',
  geral_traducao0019: 'Eliminar este tratamiento',
  geral_traducao0020: 'Agregar este tratamiento',
  geral_traducao0021: 'Inicio del tratamiento:',
  labelIntramamario: 'Intramamario',
  labelAntiInflamatorio: 'Antiinflamatorio',
  labelInjetavel: 'Inyectable',
  labelNaoDefinido: 'No definido',
  geral_traducao0026: 'Con la inclusión de un nuevo tratamiento, se interrumpirán todas las tareas de los tratamientos anteriores que están abiertos, ¿desea continuar?',
  geral_traducao0027: 'Usar este tratamiento',
  geral_traducao0028: 'Tratamiento agregado',
  labelLado: 'Lado:',
  labelPlaca: 'Placa',
  labelCriacao: 'Creación:',
  geral_traducao0034: 'Update:',
  geral_traducao0036: 'Teste SmartStrep:',
  geral_traducao0037: 'Agentes:',
  labelRealizarTratamento: '¿Realizar tratamiento?',
  geral_traducao0039: 'o',
  geral_traducao0040: 'Seleccionar tratamiento:',
  labelVerTodos: 'Ver todos',
  labelAtivo: 'Activo',
  labelInativo: 'Inativo',
  geral_traducao0044: 'No existe tratamiento sugerido para este diagnostico',
  labelAguardando: 'En espera',
  labelCurou: 'Curo',
  labelNaoCurou: 'No curo',
  labelDescartado: 'Descartado',
  labelNaoAnalisado: 'No analizado',
  geral_traducao0052: 'Crear nuevo tratamiento',
  geral_traducao0053: 'Datos no encontrados',
  labelCompartilhar002: 'COMPARTIR',
  labelPrevalencaAgentes: 'Prevalencia de agentes',
  labelFrequenciaCrescimento: 'Frecuencia de crecimiento',
  geral_traducao0057: 'Historial del animal',
  geral_traducao0058: 'Chance de Cura',
  geral_traducao0059: 'Promedio de tu rebaño',
  geral_traducao0060: 'Resultado de diagnostico',
  geral_traducao0061: 'Inténtalo más tarde',
  geral_traducao0062: 'La solicitud de informe fue enviada al servidor',
  geral_traducao0063: 'Recibirás una notificación cuando esté disponible.',
  geral_traducao0064: 'Ver detalle de calculo:',
  geral_traducao0066: 'Alto',
  geral_traducao0067: 'Baja',
  geral_traducao0068: 'Guardar:',
  geral_traducao0069: 'Confirmación Cura Clínica',
  geral_traducao0070: 'Por favor, informe el numero de vacas en lactancia de este mes, para generar el calculo de la incidencia de mastitis clínica.',
  geral_traducao0071: 'Con crecimiento',
  geral_traducao0072: 'Sin Crecimiento',
  geral_traducao0073: 'Enero',
  geral_traducao0074: 'Febrero',
  geral_traducao0075: 'Marzo',
  geral_traducao0076: 'Abril',
  geral_traducao0077: 'Mayo',
  geral_traducao0078: 'Junio',
  geral_traducao0079: 'Julio',
  geral_traducao0080: 'Agosto',
  geral_traducao0081: 'Septiembre',
  geral_traducao0082: 'OCTUBRE',
  geral_traducao0083: 'Noviembre',
  geral_traducao0084: 'Diciembre',
  geral_traducao0085: 'Desea realmente extender el tratamiento?',
  geral_traducao0087: 'Intente nuevamente mas tarde!',
  geral_traducao0088: ' y tratamientos por dia esta disponible para su descarga, para acceder al informe utilice la aplicación web',
  geral_traducao0089: 'El informe de ',
  geral_traducao0090: 'El protocolo será cerrado a partir de ahora ',
  returnGostariaRealmenteInterromperTratamento: 'Le gustaría realmente interrumpir el tratamiento?',
  geral_traducao0092: 'Facturas proximas a vencer',
  geral_traducao0093: 'Placas listas',
  geral_traducao0094: 'Espere un momento mientras consulto nuestra ',
  geral_traducao0095: 'No consta',
  geral_traducao0096: 'No realizado',
  geral_traducao0097: 'Informe que paso con la',
  geral_traducao0098: 'del día',
  geral_traducao0099: 'base de datos',
  geral_traducao0100: 'CONTINUAR TAREA',
  geral_traducao0101: 'INTERRUMPIR PROTOCOLO',
  kabekPresencaGrumo: 'Presencia de grumos',
  labelApliquei: 'Aplicado',
  labelNaoApliquei: 'No aplicado',
  labelSalvarDiagnostico: 'Guardar Diagnóstico',
  labelCuraClinicaPorTratamento: 'Cura clinica por tratamiento',
  labelDataInicial: 'Fecha Inicial',
  labelDataFinal: 'Fecha Final',
  geral_traducao0109: 'CURA[SI]',
  geral_traducao0110: 'CURA[NO]',
  labelIntramariosMaisUtilizadosComunidade: 'Intramamarios más utilizados por la comunidad de Onfarm.',
  labelInjetaveisMaisUtilizadosComunidade: 'Inyectables más utilizados por la comunidad de Onfarm.',
  labelAntiflamatoriosMaisUtilizadosComunidade: 'Antiflamatorios más utilizados por la comunidad OnFarm.',
  labelDiasATBIntramamarioMaisUtilizadosComunidade: 'Días de ATB intramamario más utilizados por la comunidad de Onfarm.',
  labelCuraClinicaComunidade: 'Cura clinica por la comunidad de Onfarm.',
  labelIncidenciaMastiteComunidade: 'Incidencia de mastitis clinica por la comunidad de Onfarm.',
  geral_traducao0117: 'Lector código de barras',
  geral_traducao0118: 'Lectura de placa',
  geral_traducao0119: 'REGISTRAR FOTO DE LA PLACA',
  geral_traducao0120: 'Situación',
  labelCancelado: 'Cancelado',
  labelConcluida: 'Terminado',
  labelAtrasada: 'Retrasada',
  geral_traducao0124: 'Del cuarto',
  geral_traducao0125: 'Del cuarto',
  geral_traducao0126: 'Realizo el Test SmartStrep?',
  geral_traducao0127: 'Si, es agalactiae',
  geral_traducao0128: 'Si, es dysgalactiae',
  geral_traducao0129: 'Enero',
  geral_traducao0130: 'Febrero',
  geral_traducao0131: 'Marzo',
  geral_traducao0132: 'Abril',
  geral_traducao0133: 'Mayo',
  geral_traducao0134: 'Junio',
  geral_traducao0135: 'Julio',
  geral_traducao0136: 'Agosto',
  geral_traducao0137: 'Septiembre',
  geral_traducao0138: 'Octubre',
  geral_traducao0139: 'Noviembre',
  geral_traducao0140: 'Diciembre',
  labelSelecioneTipoAmostra: 'Seleccione tipo de muestra:',
  geral_traducao0142: 'Grado de mastitis:',
  geral_traducao0143: 'Seleccione lado:',
  labelMastiteClinicaGrumo: 'Mastitis Clínica (Grumo)',
  geral_traducao0145: 'Mastitis Subclínica (Sin Grumos)',
  geral_traducao0146: 'Examen microbiológico de tanque',
  geral_traducao0147: '¿Está seguro de que desea reemplazar el tratamiento? Las tareas abiertas para el tratamiento actual se detendrán.',
  geral_traducao0148: '¿Quieres guardar este tratamiento?',
  geral_traducao0149: 'Usuario no habilitado para la compra.',
  geral_traducao0150: 'Pos-Parto',
  labelQuantidadeOuPorcentagem: 'Cantidad o Porcentaje',
  labelQuantidade: 'Cantidad',
  labelPorcentagem: 'Porcentaje',
  geral_traducao0154: 'Grado de mastitis',
  geral_traducao0156: 'Suma de Puntuaciones',
  geral_traducao0157: '4 o menos',
  geral_traducao0158: 'mayor que 6',
  geral_traducao0159: 'Neumonía',
  geral_traducao0160: 'Diarrea',
  geral_traducao0161: 'Fecha de Nacimiento',
  geral_traducao0162: 'Edad',
  geral_traducao0163: 'Heces',
  geral_traducao0164: 'Nariz',
  geral_traducao0165: 'Ojos ',
  geral_traducao0166: 'Hubo crecimiento?',
  geral_traducao0167: 'Proseguir',
  geral_traducao0168: 'Seleccione la muestra:',
  labelLancamentoConcluidoSalveDiagnostico: 'Lanzamiento concluido! Guarde el diagnostico:',
  geral_traducao0170: 'Fecha de la Muestra:',
  geral_traducao0171: 'Producción de leche por vaca (L):',
  geral_traducao0172: 'Media de dias de descarte de leche cuando tiene tratamiento:',
  geral_traducao0173: 'Precio/litro de leche ($):',
  geral_traducao0174: 'Precio/aplicación ($):',
  geral_traducao0175: 'Numero de aplicaciones/caso de mastitis:',
  geral_traducao0176: 'Azul claro (3 o + colonias)',
  geral_traducao0177: 'Azul oscuro metalizado (3 o + colonias)',
  geral_traducao0178: 'Violeta oscuro (3 o + colonias)',
  geral_traducao0179: 'Amarillo/verdoso (3 o +  colonias)',
  geral_traducao0180: 'Azul claro (3 o + colonias)',
  geral_traducao0181: 'Blanco grisáceo sin brillo (3 o + colonias)',
  geral_traducao0182: 'Cremosa - Brillante (3 o + colonias)',
  geral_traducao0183: 'Violeta/vino (3 o + colonias)',
  geral_traducao0184: 'Indique el color de las colonias mostradas:',
  geral_traducao0185: 'Otros Gram-positivos',
  geral_traducao0186: 'Prototheca/Levadura',
  geral_traducao0187: 'Staph. no aureus',
  geral_traducao0188: 'Muestra del Lado ',
  geral_traducao0189: 'Guardado con éxito!',
  geral_traducao0190: 'Quiere registrar lado',
  geral_traducao0192: 'Diagnóstico Lado',
  geral_traducao0193: 'Esta operación puede llevar 10 segundos.',
  geral_traducao0194: 'Seleccione el grado',
  geral_traducao0195: 'guardado con éxito.',
  geral_traducao0196: 'Usted todavia no definió un tratamiento para este caso',
  geral_traducao0197: 'SEGUIR SIN DEFINIR',
  geral_traducao0198: 'ESCOGER UN TRATAMIENTO',
  geral_traducao0199: 'Abra el habitáculo de siembra y posicione la Placa en el suporte de lectura',
  geral_traducao0200: 'Seleccione un protocolo de tratamiento',
  geral_traducao0201: 'Inconsistencia de datos enviados, intente nuevamente mais tarde.',
  geral_traducao0202: 'Escoge una opción',
  geral_traducao0203: 'Sugerencia de Rumi',
  geral_traducao0204: 'Tratamiento guardado',
  geral_traducao0205: 'Access with Biometrics',
  geral_traducao0206: 'Sin tratamiento',
  geral_traducao0207: 'Compuesto',
  geral_traducao0208: 'Fecha de Lectura',
  geral_traducao0209: 'Elegir tratamiento',
  geral_traducao0210: '¿Realizar tratamiento?',
  geral_traducao0211: 'Por favor, elige un tratamiento o marque que no va realizar tratamiento.',
  geral_traducao0212: 'Eliminar',
  geral_traducao0213: '¿Hacer de nuevo la lectura?',
  geral_traducao0214: 'Se estira Protocolo',
  labelDiario: 'Diario',
  labelMensal: 'Mensual',
  labelDiarioOuMensal: 'Diario o Mensual:',
  geral_traducao0218: 'Vacas lactantes',
  geral_traducao0219: 'Cantidad de incidencia',
  geral_traducao0220: 'Períodos de aplicación',
  geral_traducao0221: 'Agregar tratamiento',
  geral_traducao0222: 'Insertar nuevo tratamiento',
  geral_traducao0223: 'Sugerencia de',
  geral_traducao0224: 'no disponible',
  geral_traducao0225: 'En este momento, el análisis de Rumi para',
  geral_traducao0226: 'probabilidad de curación solo',
  geral_traducao0227: 'está disponible cuando se leen los resultados de mastitis clínica',
  returnVoceEstaTentandoConcluirTarefaPrevista: 'Estás intentando completar una tarea programada para ',
  returnDesejaMesmoMarcarTarefaConcluida: ' ¿Realmente deseas marcar la tarea como completada?',
  geral_traducao0230: 'Fecha diagnóstico',
  geral_traducao0231: 'Escriba el ID',
  geral_traducao0232: 'Otros Gram-neg',
  geral_traducao0233: '¿Está de acuerdo con este resultado?',
  geral_traducao0234: 'Lanzar manualmente',
  geral_traducao0235: 'Guardar Diagnóstico Lado',
  geral_traducao0236: 'Otros colores (3 o más colonias)',
  geral_traducao0237: 'Rosa (1 o más colonias)',
  geral_traducao0238: 'Rosa Claro (3 o más colonias)',
  geral_traducao0239: 'Tienda',
  geral_traducao0240: 'Puntos',
  labelAcessar: 'Acceder',
  geral_traducao0244: 'Lectura de resultados',
  geral_traducao0245: 'Conozca nuestro producto',
  geral_traducao0246: 'de monitoreo del tanque.',
  geral_traducao0247: 'Más información aquí',
  geral_traducao0248: 'Ofrecido por',
  geral_traducao0249: 'Última actualización',
  geral_traducao0250: 'ABRIR TAPA',
  geral_traducao0251: 'VERIFICAR FALLO DE COMUNICACION',
  geral_traducao0252: 'REVISE EL PROBLEMA DEL SENSOR',
  geral_traducao0253: 'SALTAR TUTORIAL',
  geral_traducao0254: 'Datos en sincronización.',
  geral_traducao0255: 'Si falta alguna información, espere a que la sincronización termine y vuelva a esta pantalla en breve.',
  geral_traducao0256: 'Error interno, por favor repara la base de datos.',
  geral_traducao0257: '¿Estás seguro de que deseas reprocesar el Diagnóstico? Hay un tratamiento relacionado y las tareas pendientes se interrumpirán.',
  geral_traducao0258: 'Rúmi está fuera de servicio - Sin internet',
  geral_traducao0259: 'Sincronizar ahora',
  geral_traducao0260: 'dato',
  labelCodigoBarras: 'Código de barras',
  geral_traducao0262: 'Código de barras invalido',
  geral_traducao0263: 'Código de barras ya utilizado',
  geral_traducao0264: 'Editar la foto',
  geral_traducao0265: 'Sin Internet',
  geral_traducao0266: 'Acceder con biometría',
  geral_traducao0267: 'Período de tratamiento',
  geral_traducao0268: 'CONSEJO DE RÚMI',
  geral_traducao0269: 'Esconder',
  geral_traducao0270: 'Divergencia de resultados',
  geral_traducao0271: '¡Prometo que la próxima vez acertaré!',
  geral_traducao0272: 'A pesar de tener',
  geral_traducao0273: 'una alta precisión',
  geral_traducao0274: 'en mi análisis de resultados, de vez en cuando podemos tener alguna discrepancia.',
  geral_traducao0275: 'Pero no se preocupe, usted puede realizar el diagnóstico de forma manual y nuestros analistas llevarán a cabo un proceso de verificación riguroso.',
  geral_traducao0276: 'REALIZAR DIAGNÓSTICO MANUAL',
  geral_traducao0277: 'Resultados basados en la base de datos de OnFarmes.',
  geral_traducao0278: 'Esta es simplemente una lista de los tratamientos que mostraron un mayor potencial de éxito según la base de datos de los OnFarmes.',
  geral_traducao0279: 'Para recomendaciones de tratamiento, consulte la opinión de su veterinario.',
  geral_traducao0280: 'Importante: los medicamentos a continuación están listados en orden de uso.',
  geral_traducao0281: 'Sin sugerencia',
  geral_traducao0282: 'Mostrar más 4 opciones',
  geral_traducao0283: 'Compartir con el veterinario',
  geral_traducao0284: 'Escriba una descripciòn',
  geral_traducao0285: 'Bacterias de Diarrea',
  geral_traducao0286: 'Suero',
  geral_traducao0287: 'Test de Diarrea',
  geral_traducao0288: 'Test de Tristeza',
  geral_traducao0289: 'Visualizar Enfermedad',
  geral_traducao0290: 'Fecha de Fin',
  geral_traducao0291: 'Fecha de Inicio',
  geral_traducao0292: 'GUARDAR ENFERMEDAD',
  geral_traducao0293: 'Score de Ojo',
  geral_traducao0294: 'Secreciòn Nasal',
  geral_traducao0295: 'Imagem indisponível',
  geral_traducao0296: 'Temperatura Rectal',
  geral_traducao0297: 'Fecha de Cura Clìnica',
  geral_traducao0298: 'RP',
  geral_traducao0299: 'Nueva Enfermedad',
  geral_traducao0300: 'No se realizó el análisis de cultivo',
  geral_traducao0301: 'Ops, parece que há algo errado com a sua ',
  geral_traducao0302: 'conexão',
  geral_traducao0303: 'Rumi',
  geral_traducao0304: ' está tentando acessar os servidores para realizar a leitura mas não está conseguindo.',
  geral_traducao0305: 'Isso pode acontecer quando sua ',
  geral_traducao0306: ' com a internet está  ',
  geral_traducao0307: 'instável ou inexistente',
  geral_traducao0308: 'Ops, parece que algo anda mal con ',
  geral_traducao0309: 'nuestros servidores',
  geral_traducao0310: ' intento acceder a los servidores para realizar la lectura pero no lo ha conseguido.',
  geral_traducao0311: 'Esto puede suceder cuando existe alguma inestabilidad ',
  geral_traducao0312: 'lado de cá',
  geral_traducao0313: 'No se preocupe, ya estamos investigando a que se debe y lo resolveremos lo ',
  geral_traducao0314: 'mas pronto',
  geral_traducao0315: ' posible.',
  btnTentarNovamente: 'INTENTAR NUEVAMENTE',
  geral_traducao0317: 'HACER DIAGNOSTICO MANUAL',
  geral_traducao0318: 'Dosis',
  returnRumiNaoProcessada: 'Rumi sin procesar, vuelva a procesar la lectura.',
  labelChanceCura: 'OPORTUNIDAD DE CURACIÓN',
  labelRegistrado: 'registrado',
  returnValidacaoCognitoEmailSenha: 'Email y/o contraseña incorrectos.',
  labelAgentSiglaAg: 'Ag',
  labelHoje: 'Hoy',
  labelAtrasadas: 'Atrasadas',
  labelAbertas: 'Abierta',
  labelConcluidas: 'Concluida',
  labelCanceladas: 'Canceladas',
  labelDias: 'días',
  labelOu: 'o',
  labelMeses: 'Meses',
  labelAindaNaoTemDados: 'Aún no hay datos',
  labelExportar: 'Exportar',
  labelRelatóriosProcessados: 'Informes procesados',
  labelCasosMastiteTratamentosDia: 'Casos de mastitis y tratamientos por día',
  returnDesejaMesmoEditar: '¿Realmente quieres editar el ',
  returnDesejaMesmoEditarLancamentoMastite: 'liberación de mastitis?',
  labelFechar: 'Cerrar',
  labelSelecioneUmLado: 'Seleccione un lado',
  labelDigiteCodigoBarras: 'Introduzca un código de barras',
  labelDataExame: 'Fecha del examen',
  labelDataLeitura: 'Fecha de lectura',
  labelVerificando: 'Comprobando',
  labelRevisarLeituraAutomatica: 'Revisar lecturas automáticas',
  labelLancamentos: 'Lanzamientos',
  labelExameMicrobiologicoLancamentoLote: 'Examen microbiológico Lanzamiento de lotes',
  returnDesejaMesmo: '¿realmente quieres',
  returnRemoveResultado: 'eliminar el resultado?',
  returnDadosSalvoSucesso: 'Datos guardados exitosamente!',
  returnOcorreuErroSalvarDadosTenteNovamente: 'Se produjo un error al guardar los datos, inténtalo de nuevo!',
  labelConfirmarSenha: 'Confirmar Contraseña',
  labelAlterar: 'Alterar',
  labelAlterando: 'Cambiar',
  returnCamposObrigatorios: 'Los campos son obligatorios',
  returnSenhaInferiorDigitos: 'Contraseña de menos de 6 dígitos',
  returnSenhasDiferentes: 'Contraseñas diferentes',
  labelTipoDocumento: 'Tipo de documento',
  labelValor: 'Valor',
  labelNumeroDocumentoFiscal: 'N.º documento fiscal',
  labelNenhumItem: 'Ningún elemento',
  labelDataVencimento: 'Fecha de vencimiento',
  labelDocumento: 'Documento',
  labelAcompanheEntrega: 'SIGA LA ENTREGA',
  labelCopiarCodigoRastreamento: 'COPIAR CÓDIGO DE SEGUIMIENTO',
  labelQuantidadePlacas: 'Cant. Placas',
  labelSemCodigoRastreio: 'Sin código de seguimiento',
  returnJaExisteLancamento: 'Ya existe un registro de Vacas en Lactancia, ¿desea reemplazarlo?',
  labelSelecioneData: 'Por favor, seleccione la fecha',
  returnDigiteQuantidadeValida: 'Por favor, introduzca una cantidad válida',
  labelSelecioneFazenda: 'Seleccione la finca',
  labelSelecionePerfil: 'Seleccione el perfil',
  labelSelecioneTipo: 'Seleccione el tipo',
  labelSelecioneCategoria: 'Seleccione la categoría',
  labelTutoriais: 'Tutoriales',
  labelIntegracaoParceiros: 'Integración con socios',
  labelHabilitar: 'Habilitar',
  labelIdentificacaoFazenda: 'Identificación de la finca',
  labelDataLacamento: "Fecha de lanzamiento",
  labelLerCodigoBarras: "ESCANEAR CÓDIGO DE BARRAS",
  labelCodigoRegistrado: "CÓDIGO REGISTRADO",
  labelDescricaoTanque: "Descripción del tanque",
  returnFavorImagemAntesSelecionar: "Por favor, adjunte la imagen antes de seleccionar el modo de conteo de colonias",
  returnTanqueSalvoSucesso: 'El tanque se guardó correctamente',
  labelOpcional: 'Opcional',
  labelMinimo9Digitos: 'Mínimo 9 dígitos',
  labelDia: "Día",
  labelAberta: "Abierta",
  labelCancelada: "Cancelada",
  labelAdicionar: "Agregar",
  labelSelecionarMedicamento: "Seleccione el medicamento",
  labelPeriodosAplicacao: "Períodos de aplicación",
  labelConcluirTratamento: "FINALIZAR TRATAMIENTO",
  labelConcluirTarefas: "FINALIZAR TAREAS",
  labelInterromperTratamento: "INTERRUMPIR TRATAMIENTO",
  labelEstenderTratamento: "EXTENDER TRATAMIENTO",
  labelInformeAplicou: "Informe si aplicó el ",
  labelInformeHouvePresencaGrumo: "Informe si hubo presencia de grumos.",
  labelTratamentoSeraEncerradoPartirDia: "El tratamiento se finalizará a partir del día",
  labelDe: "de",
  returnDesejaMesmoInterromperTratamento: "¿Realmente desea interrumpir el tratamiento?",
  returnDesejaMesmoExtenderTratamento: "¿Realmente desea extender el tratamiento?",
  labelRealizarTarefa: "Realizar tarea",
  labelAtiveDesativeNotificacoes: 'Activar o desactivar notificaciones',
  returnFavorAguardeProcessamento: 'Por favor, espere mientras se procesa.',
  returnFavorInserirDigitosPlaca: 'Por favor, introduzca los 9 dígitos de la placa.',
  returnColostroCriadoSucesso: 'Calostro creado con éxito.',
  returnCampoObrigatorio: 'Campo obligatorio.',
  returnBrincoCampoObrigatorio: 'El Arete es un campo obligatorio.',
  returnCampoBrincoNaoPodeFicarVazio: 'El campo de Arete no puede estar vacío.',
  returnPorFavorSelecioneTratamento: 'Por favor, seleccione un Tratamiento.',
  returnTemCertezaDesejaSubstituirTratamentoTarefasAbertoTratamentoAtualSeraoInterrompidas: '¿Está seguro de que desea reemplazar el Tratamiento? Las tareas abiertas del tratamiento actual serán interrumpidas.',
  returnTemCertezaDesejaSubstituirTratamentoTarefasAbertoSeraoInterrompidas: '¿Está seguro de que desea reemplazar el Tratamiento? Las tareas abiertas serán interrumpidas.',
  returnTemCertezaDesejaRemoverTratamentoTarefasAbertoSeraoInterrompidas: '¿Está seguro de que desea eliminar el Tratamiento? Las tareas abiertas serán interrumpidas.',
  returnTemCertezaDesejaExcluirTratamentoTarefasRelacionadasSeraoExcluidas: '¿Está seguro de que desea borrar el Tratamiento? Las tareas relacionadas también serán eliminadas.',
  returnFavorSelecionePeloMenosMedicamento: 'Por favor, seleccione al menos un medicamento.',
  returnFavorSelecioneIntervaloAplicacao: 'Por favor, seleccione un intervalo de aplicación.',
  returnFavorSelecioneTratamentoNaoAtivo: 'Por favor, indique si el tratamiento está activo o no.',
  returnFavorSelecioneBacteria: 'Por favor, seleccione la bacteria.',
  returnErroProcessarRelatorioTenteNovamenteMaisTarde: 'Error al procesar el informe, intente nuevamente más tarde.',
  returnCompartilhamentoRealizadoSucesso: 'Compartición realizada con éxito.',
  returnHouveFalhaNaoFoiPossivelProcessarCompartilhamentoTenteMaisTarde: 'Hubo un error y no se pudo procesar la compartición, intente nuevamente más tarde.',
  returnFavorPreenchaTodosCampos: 'Por favor, complete todos los campos.',
  returnErroComunicarOmie: 'Error al comunicarse con Omie.',
  returnVoceNaoInformouNomeUsuario: 'No proporcionó el nombre del usuario.',
  returnVoceNaoInformouLoginUsuario: 'No proporcionó el inicio de sesión del usuario.',
  returnVoceNaoInformouFazenda: 'No proporcionó la finca.',
  returnVoceNaoInformouPerfilUsuario: 'No proporcionó el Perfil del usuario.',
  returnVoceNaoInformouTelefoneEnviaremosSenhaNumeroInformado: 'No proporcionó el Teléfono. Enviaremos la contraseña al número proporcionado.',
  returnTelefoneInvalido: '¡Teléfono inválido!',
  returnUsuarioJaEstaEmUso: 'El usuario ya está en uso.',
  returnVoceDigitouCodigoDeBarrasEleDeveTerMinimoDigitos: 'Introdujo el código de barras, debe tener al menos 9 dígitos.',
  returnDescricaoTanqueObrigatoria: 'La descripción del tanque es obligatoria.',
  returnVoceJaLancou: 'Ya lo ha registrado.',
  returnEtapasDesejaContinuarLancamento: '¿3 pasos, desea continuar con el registro?',
  returnInformeHouveCrescimento: 'Indique si hubo crecimiento.',
  returnInformeCorColoniaObsPlacaConsulteGuiaCores: 'Indique el color de la colonia observada en la placa. Consulte la Guía de Colores.',
  returnArquivoEnviadoComSucesso: '¡Archivo subido con éxito!',
  returnHouveErroImportarArquivoTenteNovamenteMaisTarde: 'Hubo un error al importar el archivo, intente nuevamente más tarde.',
  returnNecessarioSelecionarArquivo: 'Es necesario seleccionar un archivo.',
  returnVoceSelecionouMastiteClinicaPorFavorSelecioneTambemGrau: 'Seleccionó mastitis clínica, por favor seleccione también el Grado.',
  returnPorFavorInformeCodigoBarrasComDigitos: 'Por favor, proporcione el código de barras con 9 dígitos.',
  returnPorFavorInformeBrincoAnimal: 'Por favor, proporcione el arete del animal.',
  returnSelecioneQuarto: 'Seleccione el cuarto.',
  returnEssaPlacaFoiUtilizadaParaLadoAE: 'Esta placa ya fue utilizada para el lado [A] y.',
  returnPorFavorVerifiqueSeNaoDeixouNenhumCampoBranco: 'Por favor, verifique si no dejó ningún campo en blanco.',
  returnInformacoesDiagnostico: 'Información del diagnóstico.',
  returnANaoEncontradas: 'No encontrada.',
  returnFavorSelecioneMedicamento: 'Por favor, seleccione el medicamento.',
  returnFavorSelecionePeloMenosBacteria: 'Por favor, seleccione al menos una bacteria.',
  returnFavorSelecionePeloMenosGrau: 'Por favor, seleccione al menos un Grado.',
  returnFavorSelecionePeloMenosObs: 'Por favor, seleccione al menos una Observación.',
  returnSelecioneAoMenosFazenda: 'Seleccione al menos una finca.',
  returnTemCertezaQueDesejaReprocessarOResultadoAgentesInformadosAnteriormenteSeraoExcluidos: '¿Está seguro de que desea reprocesar el resultado? Los agentes informados previamente serán eliminados.',
  returnVoceNaoSelecionouNenhumaFazenda: 'No ha seleccionado ninguna finca.',
  returnCompartilhamentoRealizadoComSucesso: 'Compartición realizada con éxito.',
  returnDesejaExcluirResultado: '¿Quieres eliminar el resultado?',
  labelFoto: 'Foto',
  returnDesejaAssociarTratamentoNovaDoenca: '¿Quieres asociar un tratamiento a esta nueva enfermedad?',
  labelDeletar: 'Borrar',
  labelAnexarFotoPlaca: 'ADJUNTAR FOTO DE PLACA'
}
